import React from 'react';
import { useReveal } from '../hooks/useReveal';

/**
 * Wraps children in a reveal animation container.
 * direction: 'up' | 'down' | 'left' | 'right' | 'scale'
 * delay: ms (number)
 */
function Reveal({ children, className = '', delay = 0, direction = 'up', tag: Tag = 'div' }) {
  const ref = useReveal();
  return (
    <Tag
      ref={ref}
      className={`rv rv-${direction}${className ? ' ' + className : ''}`}
      style={{ '--rv-delay': `${delay}ms` }}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
